import { PrimitiveAtom, useAtomValue } from "jotai";
import { mergeClass } from "../../utils";
import { Button } from "../Button";
import { DisplayValue } from "../DisplayValue";
import _ from "lodash";
import { publishGroups } from "./publishConfig";
import { useState } from "react";
import { Spinner } from "../Loader";
import { useSlidesPublisher } from "./useSlidesPublisher";
import { useWorksPhotosPublisher } from "./useWorksPhotosPublisher";
import { ShowBanner } from "../ShowBanner";
import { IPublishState } from "./atoms";

/**
 * Dev Notes:
 * Combined student works and school photos publishing into
 * 'school photos' on the publish state of single items
 */

const SlidesPublishBanner = (): JSX.Element => {
  const [isPublishing, setIsPublishing] = useState<boolean>(false);
  const publishState = useAtomValue(publishGroups.slides.atom);
  const upToDate = publishState.lastchange === publishState.lastpublish;
  const publish = useSlidesPublisher(setIsPublishing);
  return (
    <ShowBanner
      published={upToDate}
      handlePublishPressed={publish}
      isPublishing={isPublishing}
      modifyLabels={{
        published: "Live content is up to date",
        unpublished: "There are unpublished changes",
        setToPublished: "Push Changes",
        setToUnpublished: "Push Changes",
      }}
    />
  );
};

const IndexPublishBanner = (): JSX.Element => {
  const [isPublishing, setIsPublishing] = useState<boolean>(false);
  const publishState = useAtomValue(publishGroups.schoolphotos.atom);
  const upToDate = publishState.lastchange === publishState.lastpublish;
  const publish = useWorksPhotosPublisher(setIsPublishing);
  return (
    <ShowBanner
      published={upToDate}
      handlePublishPressed={publish}
      isPublishing={isPublishing}
      modifyLabels={{
        published: "Live content is up to date",
        unpublished: "There are unpublished changes",
        setToPublished: "Push Changes",
        setToUnpublished: "Push Changes",
      }}
    />
  );
};

const HomePublishSection = (): JSX.Element => {
  const [isPublishing, setIsPublishing] = useState<boolean>(false);
  const publishState = useAtomValue(publishGroups.schoolphotos.atom);
  const upToDate = publishState.lastchange === publishState.lastpublish;
  const publish = useWorksPhotosPublisher(setIsPublishing);
  return (
    <div className="mt-2 text-sm">
      <DisplayValue name="Last Modified" value={publishState.lastchange} />
      <DisplayValue
        name="Last Published"
        value={publishState.lastpublish}
        className={
          upToDate ? "text-unpublishedHome font-bold" : "text-primaryColor"
        }
      />
      <Button
        className="text-sm mt-2 flex gap-2"
        disabled={isPublishing}
        onClick={() => publish()}
      >
        Push Changes {isPublishing && <Spinner />}
      </Button>
    </div>
  );
};

const SlidesPublishSection = (): JSX.Element => {
  const [isPublishing, setIsPublishing] = useState<boolean>(false);
  const publishState = useAtomValue(publishGroups.slides.atom);
  const upToDate = publishState.lastchange === publishState.lastpublish;
  const publish = useSlidesPublisher(setIsPublishing);
  return (
    <div className="mt-2 text-sm">
      <DisplayValue name="Last Modified" value={publishState.lastchange} />
      <DisplayValue
        name="Last Published"
        value={publishState.lastpublish}
        className={
          upToDate ? "text-unpublishedHome font-bold" : "text-primaryColor"
        }
      />
      <Button
        className="text-sm mt-2 flex gap-2"
        disabled={isPublishing}
        onClick={() => publish()}
      >
        Push Changes {isPublishing && <Spinner />}
      </Button>
    </div>
  );
};

export {
  HomePublishSection,
  SlidesPublishSection,
  SlidesPublishBanner,
  IndexPublishBanner,
};
